import { createCategoryModule } from './features/category';

export const wbCategory = createCategoryModule();
